import _ from 'underscore';
import $ from 'jquery';

class A11YCollections {

	constructor(options) {
		if(Array.isArray(options.direction)) {
			this.direction = options.direction;
		} else {
			this.direction = [options.direction];
		}

		this.adapters = {
			elements: options.handlers.elements,
			container: options.handlers.container
		};
	}

	onKeyDown(event) {
		for(let i = 0; i < this.direction.length; i++) {
			const direction = this.direction[i];

			switch (event.key) {
				case direction.previous:
					this._handleFocusPrevious(event);
					return;
				case direction.next:
					this._handleFocusNext(event);
					return;
			}
		}
	}

	_handleFocusPrevious(event) {
		if(this._getContainer(event.target).length > 0) {
			this._cycleFocus(event, -1);

			event.preventDefault();
		}
	}

	_handleFocusNext(event) {
		if(this._getContainer(event.target).length > 0) {
			this._cycleFocus(event, 1);

			event.preventDefault();
		}
	}

	/// Adapters

	_getElements(element) {
		if(_.isFunction(this.adapters.elements)) {
			return $(this.adapters.elements(element));
		}
		return $(this.adapters.elements);
	}

	_getContainer(element) {
		if(this.adapters.container) {
			return $(this.adapters.container(element));
		}
		return $(element);
	}

	/// Private

	_cycleFocus(event, increment) {
		const index = this._getContainer(event.target).index();

		this._focus(this._getElements(event.target), index + increment);
	}

	_focus(items, index) {
		if(index >= items.length) {
			// Loop back to the first element.
			index = 0;
		}

		items.eq(index).focus();
	}

}

export default A11YCollections;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/a11y/src/js/Collections.js